import { Vendor } from 'models';
import React, { FC } from 'react';
import { Link } from 'react-router-dom';
import { makeSlug } from 'util/helpers';

interface PartnerLinkProps {
  partner: Vendor;
  children: any;
}

export const PartnerLink: FC<PartnerLinkProps> = (props: PartnerLinkProps) => {
  const partner = props.partner;
  const exhibits = partner.exhibits;
  const slug = partner.slug ?? makeSlug(partner.name);

  return <Link to={`/partner-pavilion/partner/${slug}/${exhibits[0].id}`}>{props.children}</Link>;
};
